// @ts-nocheck
import { MD3DarkTheme as DefaultTheme, configureFonts } from "react-native-paper";
import { TEXT_INPUT_FONTSIZE } from "../../utils/Typography";
import { FlatList, TouchableOpacity, View, Text } from "react-native";
import { white_smoke, light_black, highlightColor, mid_blue, quick_silver } from "../../StyleHelpers";
import { useRef, useEffect, useState } from "react";
import iconUp from "../../assets/Icons/icon_chevron-up.svg";
import iconDown from "../../assets/Icons/icon_chevron-down.svg";
import Image from "../../components/Image/Image";
import {
	fontConfig,
	StyledDropDownContainer,
	StyledListItem,
	StyledListItemText,
	StyledRightIcon,
	StyledTextError,
	StyledView,
	StyledInput,
} from "./styled";

/**
 *
 * Current lib limitation: Change color of label when text input is focused. Read: https://stackoverflow.com/questions/58786281/change-label-color-textinput-react-native-paper-onfocus
 * Specs: https://callstack.github.io/react-native-paper/text-input.html
 */
const DropDown = (props: any) => {
	const dropDownRef = useRef();
	const [dropDownSelectedValue, setDropDownSelectedValue] = useState();
	const [dropdownData, setDropDownData] = useState(props.dropDownData);
	const [isFocused, setIsFocused] = useState(false);
	const [rightIcon, setRightIcon] = useState(iconDown);
	const textStyle = { fontSize: props.isNarrow ? 21 : 25, lineHeight: props.isNarrow ? 30 : 35, color: white_smoke };

	const onDropDownChangeText = (text: string) => {
		const inputText = text.toLowerCase();

		if (!inputText) {
			setDropDownSelectedValue(inputText);
			props.onItemSelect(inputText);
			return;
		}
		setSelectedItem(false);

		setDropDownData(
			props?.dropDownData?.filter(
				(item) => item.label.toLowerCase().indexOf(inputText) >= 0 || item.value.toLowerCase().indexOf(inputText) >= 0,
			),
		);
		setDropDownSelectedValue(inputText);
	};

	const onDropDownItemPress = (item) => {
		setDropDownSelectedValue(item.value);
		props.onItemSelect(item);
		setDropDownData(props?.dropDownData);
		setIsFocused(false);
		setRightIcon(iconDown);
	};

	const onPressIcon = () => {
		if (props.disabled) return;

		if (rightIcon === iconUp) {
			setIsFocused(false);
			setRightIcon(iconDown);
			return;
		}

		setIsFocused(true);
		setRightIcon(iconUp);
	};

	const dropdownBorderStyle = () => {
		if (dropDownSelectedValue) {
			return white_smoke;
		}
		return quick_silver;
	};

	useEffect(() => {
		if (props.autoFocus === true) {
			dropDownRef.current.focus();
		}
	}, [props.autoFocus]);

	useEffect(() => {
		setDropDownData(props.dropDownData);
	}, [props.dropDownData]);

	useEffect(() => {
		setDropDownSelectedValue("");
	}, [props.onChangeValue]);

	return (
		<StyledView addLeftSpacing={props.addLeftSpacing} addRightSpacing={props.addRightSpacing}>
			<TouchableOpacity
				onPress={() => onPressIcon()}
				onBlur={() =>
					setTimeout(() => {
						setIsFocused(false);
						setRightIcon(iconDown);
					}, 200)
				}
				style={{ cursor: "pointer" }}
			>
				<StyledInput
					height={props.height}
					mode="outlined"
					disabled={!props.value && props.disabled}
					activeOutlineColor={mid_blue}
					outlineColor={dropDownSelectedValue ? white_smoke : quick_silver}
					error={props.error}
					autoComplete={false}
					placeholder={props.dropDownPlaceholder}
					secureTextEntry={props.passwordField}
					value={dropDownSelectedValue ?? props.value}
					style={{ cursor: "pointer" }}
					outlineStyle={
						!props.value && props.disabled
							? { borderColor: isFocused ? mid_blue : quick_silver, borderRadius: 16, borderWidth: 2 }
							: {
									borderColor: isFocused ? mid_blue : dropdownBorderStyle(),
									borderRadius: 16,
									borderWidth: 2,
								}
					}
					fontSize={TEXT_INPUT_FONTSIZE}
					label={
						<View style={{ left: -8, backgroundColor: light_black, cursor: "pointer" }}>
							<View
								style={{
									alignItems: "center",
								}}
							>
								<Text
									style={{
										fontSize: props.isNarrow ? 21 : 27,
										lineHeight: 28,
										fontWeight: 500,
										marginLeft: 15,
										color: white_smoke,
										backgroundColor: light_black,
										opacity: !props.value && props.disabled ? 0.5 : 1,
										cursor: "pointer",
									}}
								>
									{props.label}
								</Text>
							</View>
						</View>
					}
					onChangeText={onDropDownChangeText}
					textColor={white_smoke}
					onBlur={() =>
						setTimeout(() => {
							setIsFocused(false);
							setRightIcon(iconDown);
						}, 200)
					}
					showSoftInputOnFocus={false}
					theme={{
						...DefaultTheme,
						fonts: configureFonts({ config: fontConfig, isV3: true }),
						colors: {
							...DefaultTheme.colors,
							error: "#C3443A",
						},
					}}
					onFocus={() => {
						setIsFocused(true);
						setRightIcon(iconUp);
					}}
					ref={dropDownRef}
					maxLength={props.maxLength}
					editable={false}
				/>
				<StyledRightIcon isReduceTop={props.isReduceTop}>
					<Image source={{ uri: rightIcon }} width={30} height={30} resizeMode="contain" />
				</StyledRightIcon>
			</TouchableOpacity>
			{isFocused && (
				<StyledDropDownContainer isNarrow={props.isNarrow}>
					<FlatList
						data={dropdownData}
						renderItem={({ item }) => (
							<TouchableOpacity
								onPress={() => onDropDownItemPress(item)}
								style={item.label === dropDownSelectedValue ? { backgroundColor: highlightColor } : {}}
							>
								<StyledListItem isNarrow={props.isNarrow}>
									<StyledListItemText>
										<Text numberOfLines={1} ellipsizeMode="tail" style={textStyle}>
											{item.label}
										</Text>
									</StyledListItemText>
								</StyledListItem>
							</TouchableOpacity>
						)}
						keyExtractor={(item) => item.id}
					/>
				</StyledDropDownContainer>
			)}

			{!props.isHideError ? (
				<View style={{ marginTop: "10px", flexGrow: "0", flexBasis: "50%" }}>
					{props.error ? <StyledTextError>{props.errorMessage}</StyledTextError> : <></>}
				</View>
			) : (
				<></>
			)}
		</StyledView>
	);
};

export default DropDown;
